/* eslint-disable no-restricted-globals */
/* eslint-disable no-console */

const currentHostname = `${location.hostname}`;

const apiHostname = currentHostname.replace(`coach`, `api`);
const keycloakHostname = currentHostname.replace(`coach`, `auth`);

export const apiUrl = `${location.protocol}//${apiHostname}`;
export const keycloakUrl = `${location.protocol}//${keycloakHostname}`;

// logging for easy debugging
console.debug(`API URL: ${apiUrl}`);
console.debug(`Keycloak URL: ${keycloakUrl}`);
